module.exports = __webpack_public_path__ + "src/assets/textures/serological/plane_mat32.jpg";